import { Box, Card, CardContent, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { CostLine } from "./cost-line"
import { CostFigure } from "./cost-figure"

export function CostTotalCard({ costResult, currencySymbol }) {
    const fixedTotal = (costResult?.fixedContracts || []).reduce(addContractAmount, 0)
    const ruleAdjustmentsTotal = costResult?.ruleFixedAdjustmentsTotal || 0
    const modifiersTotal = (costResult?.modifiersApplied || []).reduce(addModifierContribution, 0)

    return (
        <Card sx={{ flex: 1, bgcolor: "#DEF2F4" }}>
            <CardContent sx={{ p: 2.5, pb: 3 }}>
                <Stack spacing={1.5}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                        <Stack spacing="12px">
                            <Typography variant="h3" sx={{ fontSize: "18px !important" }}>
                                Annual Cost
                            </Typography>
                            <CostFigure
                                value={costResult.grandTotal}
                                currencySymbol={currencySymbol}
                                variant="h3"
                                sx={{ fontSize: "32px !important" }}
                                dataCy="annual-cost-total"
                            />
                        </Stack>
                        <Box
                            sx={{
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                                bgcolor: "primary.main",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Iconify icon="majesticons:money-line" sx={{ color: "common.white", fontSize: 24 }} />
                        </Box>
                    </Stack>
                    <Stack spacing={1}>
                        <CostLine
                            label="Trade Costs"
                            value={costResult.maintenanceSubtotal}
                            currencySymbol={currencySymbol}
                        />
                        <If value={!!fixedTotal}>
                            <CostLine label="Fixed Contracts" value={fixedTotal} currencySymbol={currencySymbol} />
                        </If>
                        <If value={!!ruleAdjustmentsTotal}>
                            <CostLine
                                label="Rule Adjustments"
                                value={ruleAdjustmentsTotal}
                                currencySymbol={currencySymbol}
                            />
                        </If>
                        <If value={!!modifiersTotal}>
                            <CostLine label="Modifiers" value={modifiersTotal} currencySymbol={currencySymbol} />
                        </If>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )

    function addContractAmount(sum, c) {
        return sum + (c.amount || 0)
    }

    function addModifierContribution(sum, m) {
        return sum + (m.contribution || 0)
    }
}
